export enum FRAME_OF_REFERENCE_URL {
  INFRASTRUCTURE = "infrastructure",
  INFRASTRUCTURE_ELEMENT = "infrastructureelement",
  ACTOR = "actor",
  BEHAVIOR = "behavior",
  EQUIPMENT = "equipment",
  TAG = "tag",
}

export enum COLLECTION_INDEX {
  INFRASTRUCTURE = 0,
  INFRASTRUCTURE_ELEMENT = 1,
  ACTOR = 2,
  BEHAVIOR = 3,
  EQUIPMENT = 4,
  TAG = 5,
  SYSTEM = 6,
}

export class CollectionRoutingUtils {
  private static readonly COLLECTION_INDEX_TO_URL_MAP = {
    [COLLECTION_INDEX.INFRASTRUCTURE]: FRAME_OF_REFERENCE_URL.INFRASTRUCTURE,
    [COLLECTION_INDEX.INFRASTRUCTURE_ELEMENT]: FRAME_OF_REFERENCE_URL.INFRASTRUCTURE_ELEMENT,
    [COLLECTION_INDEX.ACTOR]: FRAME_OF_REFERENCE_URL.ACTOR,
    [COLLECTION_INDEX.BEHAVIOR]: FRAME_OF_REFERENCE_URL.BEHAVIOR,
    [COLLECTION_INDEX.EQUIPMENT]: FRAME_OF_REFERENCE_URL.EQUIPMENT,
    [COLLECTION_INDEX.TAG]: FRAME_OF_REFERENCE_URL.TAG,
  };

  static getCollectionListRoute(collectionIndex: number): string {
    const urlPath = this.COLLECTION_INDEX_TO_URL_MAP[collectionIndex];
    
    switch (collectionIndex) {
      case COLLECTION_INDEX.INFRASTRUCTURE:
      case COLLECTION_INDEX.INFRASTRUCTURE_ELEMENT:
      case COLLECTION_INDEX.ACTOR:
      case COLLECTION_INDEX.BEHAVIOR:
      case COLLECTION_INDEX.EQUIPMENT:
      case COLLECTION_INDEX.TAG:
        return `/frameofreference/${urlPath}`;
      case COLLECTION_INDEX.SYSTEM:
        return "/system-proof/system/list";
      default:
        return "/collection";
    }
  }

  static getCollectionUrl(collectionIndex: number): string {
    return this.COLLECTION_INDEX_TO_URL_MAP[collectionIndex] || '';
  }
}